import {UserAgent} from "@/model/user_agent";
import {Branch, IBranch} from "@/model/branch";
import {message} from "ant-design-vue";
import {api} from "@/lib/api";
import dayjs from "dayjs";

export interface IBrandInfo {
    content: string;
    images: string[];
}

export interface IBrand extends IBrandInfo {
    brand_id: string;
    agent_id: string;
    icon: string | null;
    name: string;
    branches: IBranch[];
    create_at: string;
    trash_at: string | null;
}

export class Brand {
    readonly branches: { [key: string]: Branch } = {}

    constructor(readonly userAgent: UserAgent, readonly meta: IBrand) {
        meta.branches.forEach(br => this.branches[br.branch_id] = new Branch(this, br))
    }

    async updateIconAndName(icon: string | null, name: string) {
        const done = message.loading('保存中', 0)
        return api({
            url: `user/${this.meta.agent_id}/brand/${this.meta.brand_id}`,
            method: 'PUT',
            data: Object.assign(this.meta, {icon, name})
        }).then(() => {
            this.meta.icon = icon
            this.meta.name = name
        }).finally(done);
    }

    async updateIcon(images: string[]) {
        if (images.length == 0) return
        const done = message.loading('保存中', 0)
        return api({
            url: `user/${this.meta.agent_id}/brand/${this.meta.brand_id}`,
            method: 'PUT',
            data: Object.assign(this.meta, {icon: images[0]})
        }).then(() => {
            this.meta.icon = images[0]
        }).finally(done);
    }

    async updateName(name: string): Promise<void> {
        if (name.length < 2) return Promise.reject('字数太短');
        const done = message.loading('保存中', 0)
        return api({
            url: `user/${this.meta.agent_id}/brand/${this.meta.brand_id}`,
            method: 'PUT',
            data: Object.assign(this.meta, {name})
        }).then(() => {
            this.meta.name = name
        }).finally(done);
    }

    async updateInfo(info: IBrandInfo): Promise<unknown> {
        const done = message.loading('更新中', 0)
        return api({
            url: `user/${this.meta.agent_id}/brand/${this.meta.brand_id}/info`,
            method: 'PUT',
            data: Object.assign(this.meta, info)
        }).finally(done)
    }

    async remove(): Promise<void> {
        if (this.meta.brand_id == this.userAgent.meta.account.active_brand_id) {
            message.error('此品牌已被选中');
            return Promise.reject('此品牌已被选中')
        }
        const done = message.loading('删除中', 0)
        return api({url: `user/${this.meta.agent_id}/brand/${this.meta.brand_id}`, method: 'DELETE'}).then(() => {
            this.meta.trash_at = dayjs().format('YYYY-MM-DD HH:mm:ss');
        }).finally(done);
    }

    async restore(): Promise<void> {
        const done = message.loading('恢复中', 0)
        return api({url: `user/${this.meta.agent_id}/brand/${this.meta.brand_id}`, method: 'PATCH'}).then(() => {
            this.meta.trash_at = null
        }).finally(done);
    }

    async newBranch(b: IBranch): Promise<Branch> {
        return await api<void, IBranch>({
            url: `user/${this.meta.agent_id}/brand/${this.meta.brand_id}/branch`,
            method: 'POST',
            data: b
        }).then(res => {
            // this.userAgent.meta.brands.find(b => b.brand_id == b.brand_id)?.branches.push(res)
            this.meta.branches.push(res)
            this.branches[res.branch_id] = new Branch(this, res)
            return this.branches[res.branch_id];
        })
    }

}
